import * as bootsrtap from "bootstrap";

export default defineNuxtPlugin(nuxtApp => {

    // now available on `nuxtApp.$injected`
    nuxtApp.provide('bootstrap', () => bootstrap)

})

